import { createRouter, createWebHistory } from 'vue-router';
import HomePage from '../views/HomePage.vue';
import TrailerPage from '../views/TrailerPage.vue';
import AboutUsPage from '../views/AboutUsPage.vue';
import PartsService from '../views/PartsService.vue';
import CareersPage from '../views/CareersPage.vue';
import JobDetail from '../views/JobDetail.vue';

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomePage,
  },
  {
    path: '/trailers',
    name: 'TrailerPage',
    component: TrailerPage,
  },
  {
    path: '/about-us',
    name: 'AboutUsPage',
    component: AboutUsPage,
  },
  {
    path: '/parts-service',
    name: 'PartsService',
    component: PartsService,
  },
  {
    path: '/careers',
    name: 'CareersPage',
    component: CareersPage,
  },
  {
    path: '/careers/job/:id',
    name: 'JobDetail',
    component: JobDetail,
  },
  // Legacy redirects for old QR codes
  {
    path: '/index.php/news',
    redirect: '/'
  },
  // Add more routes here as needed
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else if (to.hash) {
      return new Promise((resolve) => {
        setTimeout(() => {
          const element = document.querySelector(to.hash);
          if (element) {
            resolve({
              el: to.hash,
              behavior: 'smooth',
            });
          } else {
            resolve({ top: 0 });
          }
        }, 300);
      });
    } else {
      return { top: 0 };
    }
  },
});

export default router;
